// extracted by mini-css-extract-plugin
module.exports = {"facetContent":"FacetContent_facetContent__aih2n","groupName":"FacetContent_groupName__6Iza3"};